export default window.resmioApp.config['src/config']
